export default __webpack_public_path__ + "images/newIframe/setup-shared-mailbox-illustration@3x.png";